/*Define all common constants*/
export const AZ_az_09 = /^[a-zA-Z0-9]+$/
export const REGEX_NUMERIC = /^[0-9+]*$/
export const REGEX_MAIL =  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
export const REGEX_HALF_WIDTH =/^[ｦ-ﾟｧ-ﾝﾞﾟ\u0021-\u007E \uFF61-\uFFEF ]+$/
export const REGEX_DATE = /^([1-9][0-9][0-9][0-9])[-/](0?[1-9]|1[0-2])[-/](0?[1-9]|[12][0-9]|3[01])$/
export const REGEX_DATE_SAVE = /^([1-9][0-9][0-9][0-9])[-/](0?[1-9]|1[0-2])[-/](0?[1-9]|[12][0-9]|3[01])$/

/* Half Width Constants */
export const HALF_HYPHEN = "ｰ";

/* Pagination Constants */
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_NUM = 1;
export const NO_RECORDS_FOUND = "表示するデータがありません。";

/*Login roles*/
export const USER = "ROLE_USER";
export const ADMIN = "ROLE_ADMIN";

/* Results */
export const ERROR = "ERROR";
export const SUCCESS = "SUCCESS";

export const ERROR_BEHIND_DATA = "ERROR_BEHIND_DATA";
export const ERROR_AFTER_DEADLINE = "ERROR_AFTER_DEADLINE";
export const ERROR_PARTNER_CONFLICT = "ERROR_PARTNER_CONFLICT";
export const ERROR_INVALID_ORDER_CONTROL_PATTERN = "ERROR_INVALID_ORDER_CONTROL_PATTERN";
export const DEFAULT_ID = "0";
export const DEFAULT_HOUR_MINUTE = "00";

/* Short Values */
export const SHORT_TRUE = 1;
export const SHORT_FALSE = 0;

/* Time prefix*/
export const PREFIX_HOUR = "0";

/* Condition */
export const KANA_YES = "はい";
export const KANA_NO = "いいえ";

/* Colors */
export const GREEN = "green";
export const RED = "red";

/*Modes*/
export const MODE_ADD = "add";
export const MODE_EDIT = "edit";
export const MODE_COPY = "copy";

/* Input types*/
export const NUMBER = "number";

/*Length*/
export const MAX_INT = 2147483646;
export const MIN_INT = 0;
export const MAX_LONG = 922337203685477520;
export const MIN_LONG = 0;
export const MAX_BIGINT = 999999999999999999;
export const MIN_LOGIN_CHAR = 7;
export const EMPTY_COUNT = 0;
export const EMPTY_STRING = "";
export const FIRST_INDEX  = 0;
export const SINGLE_RECORD  = 1;
export const ONE_DAY  = 1;
export const MAX_12_BIGDECIMAL  = 10000000000;
export const MAX_11_DIGITS  = 99999999999;
export const MAX_10_DIGITS  = 9999999999;
export const MAX_DIGITS_LENGTH  = 18;
export const MIN_TIME_LENGTH = 3;

/*Fields*/
export const FIELD_CHECKBOX = "checkbox";
export const FIELD_CHECKBOX_NAME = "checkboxItems";
export const FIELD_PROPOSAL_DATE = "proposalDate";
export const FIELD_PROPOSAL_STARTDATE = "proposalStartDate";
export const FIELD_PROPOSAL_ENDDATE = "proposalEndDate";
export const FIELD_STRING_STARTDATE = "strStartDate";
export const FIELD_STRING_ENDDATE = "strEndDate";
export const FIELD_STARTDATE = "startDate";
export const FIELD_ENDDATE = "endDate";
export const FIELD_PROPOSAL_IDS = "proposalIds";
export const FIELD_PAGE_SIZE = "pageSize";
export const FIELD_PAGE_NUM = "pageNum";
export const FIELD_USER_CODE = "userCode";
export const FIELD_PRODUCT_PRICE = "productPrice";
export const FIELD_MAX_VAL = "maxVal";
export const FIELD_MIN_VAL = "minVal";
export const FIELD_MULTI_VAL = "multiVal";
export const FIELD_SEND_DATETIME = "sendDateTime";
export const FIELD_SHIPPING = "shipping";
export const FIELD_DEADLINE = "deadline";
export const FIELD_PRODUCT_ORDER = "orderedProducts";
export const FIELD_CHECKBOX_INDETERMINATE = "checkbox_indeterminate";

/*Date*/
export const DAYS = "days";
export const MONTHS = "months";
export const MONTH = "month";
export const HOURS = "hours";
export const MINUTES = "minutes";
export const DAY_KANA = ["日", "月", "火", "水", "木", "金","土"];
export const DAY_KANA_CUSTOM = ["月", "火", "水", "木", "金","土", "日" ];
export const MAX_DB_DATE = "9999/12/26";
export const MIN_DB_DATE = "1000/01/06";
export const MIN_DB_DATE_EXACT = "1000/01/01";
export const MAX_DB_DATE_EXACT = "9999/12/31";
export const DATE_FORMAT = "YYYY/MM/DD";
export const DASHED_DATE_FORMAT = "YYYY-MM-DD";
export const DATETIME_FORMAT = "YYYY/MM/DD HH:mm:ss";
export const FILE_DATE_FORMAT = "YYYYMMDDHHmmss";
export const PREDICTION_DATE_FORMAT = "YYYYMMDD";
export const MONTH_DAY_FORMAT = "MM/DD";
export const TIME_FORMAT = "HH:mm:ss";
export const HOUR_MINUTE_FORMAT = "HHmm";
export const JA_LOCALE = "ja";
export const JA_CALENDAR_FORMAT = "YYYY年 M月";
export const MESSAGE_DATETIME_FORMAT = "MM/DD HH:mm";

/* Global Timezone */
export const DEFAULT_TIMEZONE = "Asia/Tokyo";

/*Fixed codes*/
export const PRODUCT_CODE = "productCode";
export const PRODUCTCLASS_CODE = "productClassCode";
export const ORDERPATTERN_CODE = "controlPatternCode";
export const ORDERPATTERN_NAME = "controlPatternName";

/*Status*/
export const ORDER_ALL = "すべて";
export const ORDER_ONGOING = "締切前";
export const ORDER_CLOSED = "締切済";

export const ORDER_DL_ONGOING = 0;
export const ORDER_DL_CLOSED = 1;

/*Column Names*/
export const ORDERCONTROL_SELECT = "orderControlSelect";
export const PROPOSAL_ID = "proposalId";
export const PROPOSAL_NAME = "proposalName";
export const PROPOSAL_ID_LABEL = "商品提案グループID";
export const PROPOSAL_NAME_LABEL = "商品提案グループ名";
export const ORDER_TABLE = "order-table";
export const PROPOSAL_TABLE = "proposal-table";

/* Checkbox Main */
export const CHECKBOX_PROPOSAL = "checkbox_proposal";
export const CHECKBOX_ORDERS = "checkbox_orders";

/* File formats */
export const FILE_CSV = "csv";
export const FILE_PDF = "pdf";
export const FILE_XLSX = "xlsx";

export const ORDER_CSV= "受注データ_";
export const ORDER_XLS = "受注集計表_";

/* Classname Check */
export const MOBILE_NUMBER_INPUT = "mobile-number-input";

/* Mobile Pages Name */
export const MOBILE_ORDERS_LIST = "発注一覧（単日）";
export const MOBILE_MONTHLY_LIST = "発注一覧（月間）";
export const MOBILE_CONTACT_LIST = "取引先連絡一覧";
export const MOBILE_CONTACT_VIEW = "取引先連絡明細";

/* Mobile Pages with Return button */
export const MOBILE_HEADER_RETURN = [MOBILE_MONTHLY_LIST, MOBILE_CONTACT_VIEW];